import { AuthenticationDrawersTypes } from '~/components/AuthenticationDrawer/AuthenticationDrawer.types'

export const NEW_TAB_LINK_TARGET = '_blank'

/**
 * Opens the create account drawer
 */
export const REGISTER_DRAWER_HREF = `#${AuthenticationDrawersTypes.Register}`

/**
 * Opens the sign in drawer
 */
export const LOGIN_DRAWER_HREF = `#${AuthenticationDrawersTypes.Login}`

/**
 * Where a Standard customer is sent to join the member program
 */
export const ACCOUNT_SETTINGS_HREF = '/account'
